import { inject, Injectable } from '@angular/core';
import { HttpMainService } from '../http-main.service';
import { map, Observable } from 'rxjs';
import { ListModel, SymbolResponseModel } from '@itb-monorepo/models';

@Injectable()
export class SymbolsService {
    private _HttpMainService = inject(HttpMainService);
    baseUrl = '/trade/';


    list(): Observable<ListModel<SymbolResponseModel>> {
        var params = {
            skip: 0,
            take: 1000
        }
        return this._HttpMainService.get<ListModel<SymbolResponseModel>>(this.baseUrl + "v1/instruments", params);
    }

    price(sym: string): Observable<SymbolResponseModel> {
        return this._HttpMainService.get<SymbolResponseModel>(this.baseUrl + "v1/instruments/" + sym)
            .pipe(
                map(s => ({ ...s, bid: sym != s.symbol ? 1 / s.bid : s.bid }))
            );
    }

}
